<template>
  <v-progress-linear
    indeterminate
    class="loader"
    color="#000"
  />
</template>

<script>
export default {
  props: { },
  data() {
    return{ }
  },
  computed: { },
  methods:{ },
}
</script>

<style>
.loader {
  margin: 2px 0px;
  text-align: center;
}
</style>